export default "__VITE_ASSET__KWuFScgh__"